<template>
  <div>
    <app-spinner v-if="!group_detail" />
    <template v-else>
      <app-cells position="between">
        <app-cells :indent="false">
          <h1 class="title">
            <button
              @click="onCopyLink"
              class="detail-title"
            >
              {{ group_detail.name }} ({{ group_detail.pax }}) ID: {{ $route.params.id }}
            </button>
          </h1>
          <div class="status-title" :style="{ 'backgroundColor': group_detail.type.color || '#5f5f5f' }">
            {{ group_detail.type.name }}
          </div>
          <div v-if="group_detail.water_for_cooking" class="status-tag" style="background-color: #77b017">Bottled water</div>
        </app-cells>
        <a
          v-if="is_superuser"
          :href="`${admin_url}climbing/group/${$route.params.id}/change/`"
          target="_blank"
          class="btn btn--blue"
        >
          Django
        </a>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <button
            v-if="show_edit_btn_main"
            class="info-cards__control"
            :class="{ 'info-cards__control--loading': !is_r_t_loading }"
            @click="onShowModalEdit('main')"
          >
            <img v-if="is_r_t_loading" src="@/assets/img/edit-table-icon.svg" alt="">
            <img v-else src="@/assets/img/preloader.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row">
              <div class="info-cards__row-item info-cards__row-item--full">
                <span>Route:</span><span>{{ group_detail.route.name }} {{ group_detail.route.duration }}</span>
              </div>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Tour start:</span><span>{{ dateFormat(group_detail.tour_start) }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Tour finish:</span><span>{{ dateFormat(group_detail.tour_end) }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Resupply:</span><span>{{ dateFormat(group_detail.resupply) }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Summit:</span><span>{{ dateFormat(group_detail.summit) }}</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card">
          <button
            v-if="show_edit_btn_1"
            @click="onShowModalEdit('start')"
            class="info-cards__control"
            :class="{ 'info-cards__control--loading': !is_u_loading }"
          >
            <img v-if="is_u_loading" src="@/assets/img/edit-table-icon.svg" alt="">
            <img v-else src="@/assets/img/preloader.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Starting point:</span><span>{{ group_detail.starting_point ? group_detail.starting_point.short_name : '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Meeting time:</span><span>{{ group_detail.meeting_time ? group_detail.meeting_time : '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Departure managers:</span><span>{{ group_detail.departure_managers.length ? group_detail.departure_managers.length : '-' }}</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card">
          <button
            v-if="show_edit_btn_2"
            @click="onShowModalEdit('room')"
            class="info-cards__control"
            :class="{ 'info-cards__control--loading': !is_r_loading }"
          >
            <img v-if="is_r_loading" src="@/assets/img/edit-table-icon.svg" alt="">
            <img v-else src="@/assets/img/preloader.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>GPS:</span>
              <a v-if="group_detail.gps" :href="group_detail.gps.shared_link" class="info-cards__link" target="_blank">Open</a>
              <span v-else>-</span>
              <a v-if="is_general_climbing && group_detail.gps" :href="group_detail.gps.edit_link" class="info-cards__link" target="_blank">Edit</a>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Chief guide:</span>
              <span v-if="group_detail.chief_guide">{{ group_detail.chief_guide.full_name }}</span>
<!--              <router-link-->
<!--                  v-if="group_detail.chief_guide"-->
<!--                  :to="{ name: 'climbing-mountain-crew-detail', params: { id: group_detail.chief_guide.id } }"-->
<!--                  class="info-cards__link"-->
<!--                  target="_blank"-->
<!--              >-->
<!--                {{ group_detail.chief_guide.full_name }}-->
<!--              </router-link>-->
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-holder">
        <app-form-group label="Notes for mountain crew (appears in printing documents)" class="form-group--no-indent">
          <app-textarea
            v-model="group_detail.notes_climbing_manager"
            rows="5"
            @change.native="onUpdateNotes('notes_climbing_manager')"
            placeholder="Write a notes"
            :readonly="is_climbing_assistant"
          />
        </app-form-group>
        <app-form-group label="Notes for operation managers (appears in calendar)" class="form-group--no-indent">
          <vue-editor v-model="group_detail.notes_calendar" class="detail-editor" @blur="onUpdateNotes('notes_calendar')" :editor-toolbar="custom_toolbar" />
        </app-form-group>
      </div>
      <app-tabs :tabs="tabs_to_show" />
      <transition name="fade" mode="out-in">
        <router-view
          :groupDetail="group_detail"
          @getClimbingInfo="getClimbingInfo"
          @refreshTabCounts="getTabCounts"
        />
      </transition>
      <modal
          name="climbing-group-main-form"
          :width="400"
          :height="'auto'"
          :scrollable="true"
          :adaptive="true"
          :clickToClose="false"
          class="modal-not-overflow"
          draggable=".popup__title"
          :reset="true"
      >
        <div class="popup">
          <button @click="$modal.hide('climbing-group-main-form')" class="popup__close" type="button"></button>
          <div class="popup__title">Updating group</div>
          <div v-if="modal_type === 'main'" class="popup__body">
            <form @submit.prevent="onCheckForm">
              <app-form-group label="Group name" label-for="name" required>
                <app-input
                    v-model="form.name"
                    @change.native="$v.form.name.$touch()"
                    :error="$v.form.name.$error"
                    id="group_name"
                    placeholder="Group name"
                    name="group_name"
                />
                <template #error>
                  <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
                </template>
              </app-form-group>
              <template v-if="($store.state.userGroups.map(item => item.code).includes('sales_manager') && group_detail.type.code !== 'join') || show_edit_btn_1">
                <app-form-group label="Route" required>
                  <app-select
                    v-model="form.route"
                    :reduce="item => item.id"
                    :options="routes_options"
                    :clearable="false"
                    :display-field="option => `${option.name} ${option.duration}`"
                    placeholder="Route"
                    :error="$v.form.route.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.route.$dirty && !$v.form.route.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Type" required>
                  <app-select
                    v-model="form.type"
                    :reduce="item => item.code"
                    :options="group_type_options"
                    :clearable="false"
                    placeholder="Type"
                    :error="$v.form.type.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.type.$dirty && !$v.form.type.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Tour start" required>
                  <app-date-picker
                    v-model="form.tour_start"
                    placeholder="Tour start"
                    :error="$v.form.tour_start.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.tour_start.$dirty && !$v.form.tour_start.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <app-cells position="center" :indent="false">
                <app-button :disabled="$v.form.$error" type="submit" ref="submit">Save</app-button>
              </app-cells>
            </form>
          </div>
        </div>
      </modal>
      <modal
        name="climbing-group-start-form"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
      >
        <div class="popup">
          <button @click="$modal.hide('climbing-group-start-form')" class="popup__close" type="button"></button>
          <div class="popup__title">Update starting info</div>
          <div v-if="modal_type === 'start'" class="popup__body">
            <form @submit.prevent="onCheckForm">
              <app-form-group label="Starting point" required>
                <app-select
                  @input="onLocationSelected"
                  @search="onPointSearch"
                  v-model="form.starting_point"
                  :options="point_options"
                  :clearable="false"
                  placeholder="Starting point"
                  :error="$v.form.starting_point.$error"
                />
                <template #error>
                  <div v-if="$v.form.starting_point.$dirty && !$v.form.starting_point.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Meeting time" label-for="meeting_time" required>
                <app-input
                  v-model="form.meeting_time"
                  v-mask="'99:99'"
                  placeholder="Meeting time"
                  autocomplete="off"
                  id="meeting_time"
                  name="meeting_time"
                  @paste.native.prevent
                  :error="$v.form.meeting_time.$error"
                />
                <template #error>
                  <div v-if="$v.form.meeting_time.$dirty && $v.form.meeting_time.$invalid">Wrong time</div>
                  <div v-if="$v.form.meeting_time.$dirty && !$v.form.meeting_time.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Departure managers">
                <app-select
                  v-model="form.departure_managers"
                  :reduce="item => item.id"
                  :options="users_options"
                  :display-field="option => `${option.first_name} ${option.last_name}`"
                  label="first_name"
                  multiple
                  placeholder="Departure managers"
                />
              </app-form-group>
              <app-cells position="center" :indent="false">
                <app-button :disabled="$v.form.$error" type="submit" ref="submit">Update info</app-button>
              </app-cells>
            </form>
          </div>
        </div>
      </modal>
      <modal
        name="climbing-group-room-form"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
      >
        <div class="popup">
          <button @click="$modal.hide('climbing-group-room-form')" class="popup__close" type="button"></button>
          <div class="popup__title">Update info</div>
          <div v-if="modal_type === 'room'" class="popup__body">
            <form @submit.prevent="onCheckForm">
              <template v-if="!is_sales_manager">
                <app-form-group label="GPS">
                  <app-select
                    v-model="form.gps"
                    :options="gps_options"
                    :display-field="option => `${option.name} (${option.number})`"
                    placeholder="GPS"
                  />
                </app-form-group>
                <app-form-group label="Chief guide">
                  <app-select
                    @search="onGuideSearch"
                    v-model="form.chief_guide"
                    :options="employees_options"
                    label="full_name"
                    placeholder="Chief guide"
                  />
                </app-form-group>
              </template>
              <app-cells position="center" :indent="false">
                <app-button :disabled="$v.form.$error" type="submit" ref="submit">Update info</app-button>
              </app-cells>
            </form>
          </div>
        </div>
      </modal>
    </template>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { format, parse } from 'date-fns'
import {
  getClimbingGPS,
  getClimbingGroupTabCounts,
  getClimbingGroupType,
  getClimbingMountainCrewListSearch,
  getClimbingRoutes,
  getClimbingsGroup,
  getGoogleSearch,
  getUsers,
  patchClimbingsGroups,
  postLocation,
} from '@/http'
import { helpers, required, url } from 'vuelidate/lib/validators'
import { debounce } from 'lodash'
import { VueEditor } from 'vue2-editor'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'ClimbingGroupsDetailLayout',
  components: { AppTabs, VueEditor },
  data() {
    return {
      group_detail: null,
      custom_toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ['clean']
      ],
      tabs: [
        { name: 'climbing-groups-detail-clients', label: 'Clients', countKey: 'clients', roles: [] },
        { name: 'climbing-groups-detail-np', label: 'NP',  roles: ['climbing_supervisor', 'climbing_manager'] },
        { name: 'climbing-groups-detail-tents', label: 'Tents', countKey: 'tents', roles: [] },
        { name: 'climbing-groups-detail-services', label: 'Additional services', countKey: 'additional_services', roles: [] },
        { name: 'climbing-groups-detail-requests', label: 'Special requests', countKey: 'special_requests', countTheme: 'danger', roles: [] },
        { name: 'climbing-groups-detail-food', label: 'Food', roles: [] },
        { name: 'climbing-groups-detail-transfers', label: 'Transfers', countKey: 'transfers', roles: ['general_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'operations_supervisor'] },
        { name: 'climbing-groups-detail-hotels', label: 'Hotels', roles: ['general_manager', 'operations_manager', 'operations_supervisor', 'sales_supervisor', 'sales_manager'] },
        { name: 'climbing-groups-detail-bed-in-twin', label: 'Bed in twin', roles: ['general_manager', 'operations_supervisor', 'sales_supervisor', 'sales_manager'] },
        { name: 'climbing-groups-detail-bed-in-twin-old', label: 'Bed in twin (Old)', roles: ['general_manager', 'operations_supervisor', 'sales_supervisor', 'sales_manager'] },
        { name: 'climbing-groups-detail-briefings', label: 'Briefings', roles: ['general_manager', 'support', 'sales_manager', 'sales_supervisor', 'operations_manager', 'operations_supervisor'] },
        { name: 'climbing-groups-detail-arrivals', label: 'Arrivals', roles: ['general_manager', 'operations_manager', 'operations_supervisor'] },
        { name: 'climbing-groups-detail-downloads', label: 'Downloads', roles: ['general_manager', 'support', 'sales_supervisor', 'operations_supervisor', 'climbing_supervisor', 'climbing_manager', 'climbing_assistant'] },
        { name: 'climbing-groups-detail-uploads', label: 'Uploads', roles: ['general_manager', 'climbing_supervisor', 'climbing_manager'] },
        { name: 'climbing-groups-detail-calculations', label: 'Calculations', roles: ['general_manager'] },
      ],
      tabs_to_show: [],
      tab_counts: null,
      form: {},
      routes_options: [],
      modal_type: '',
      point_options: [],
      group_type_options: [],
      users_options: [],
      gps_options: [],
      employees_options: [],
      board_url: process.env.VUE_APP_BOARD_URL,
      admin_url: process.env.VUE_APP_ADMIN_URL,
      is_r_t_loading: true,
      is_u_loading: true,
      is_r_loading: true,
    }
  },
  validations() {
    const form = {}

    if (this.modal_type === 'main') {
      form.name = { required }
      form.route = { required }
      form.type = { required }
      form.tour_start = { required }
    }
    if (this.modal_type === 'start') {
      form.meeting_time = { timeRegex, required }
      form.starting_point = { required }
    }
    if (this.modal_type === 'room') {
      form.climbing_list = { url }
    }
    return { form }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_general_climbing() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_manager')
    },
    show_edit_btn_main() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('support') ||
        (this.$store.state.userGroups.map(item => item.code).includes('sales_manager') && this.group_detail.type.code !== 'join')
    },
    show_edit_btn_1() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('support')
    },
    show_edit_btn_2() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_assistant') ||
        this.$store.state.userGroups.map(item => item.code).includes('support')
    },
    is_climbing_assistant() {
      return this.$store.state.userGroups.map(item => item.code).includes('climbing_assistant')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_superuser() {
      return this.$store.state.userData.is_superuser
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
  created() {
    this.getClimbingInfo()
    this.getTabCounts()
  },
  methods: {
    onLocationSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.form.starting_point = res.data
      })
    },
    onCopyLink() {
      const string = `${this.board_url}climbing/groups/${this.$route.params.id}`
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    onUpdateNotes(field) {
      patchClimbingsGroups(this.$route.params.id, { [field]: this.group_detail[field] })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Notes saved',
          })
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    tabsToShow() {
      if (!this.group_detail) return
      const accommodation = this.group_detail.route.accommodation_type
      const userRoles = this.$store.state.userGroups.map(item => item.code)
      this.tabs_to_show = this.tabs
        .filter(item => accommodation || item.countKey !== 'tents')
        .filter(item => item.label !== 'Bed in twin' || this.group_detail.type?.code === 'join')
        .filter(item => !item.roles.length || item.roles.some(role => userRoles.includes(role)))
        .map(item => {
          const tab = { ...item }
          if (item.countKey && this.tab_counts) tab.count = this.tab_counts[item.countKey]
          if (tab.countTheme === 'danger' && !tab.count) delete tab.countTheme
          if (item.countKey === 'tents' && accommodation?.code === 'huts') tab.label = 'Huts'
          return tab
        })
    },
    getTabCounts() {
      getClimbingGroupTabCounts(this.$route.params.id)
        .then(response => {
          this.tab_counts = response.data
          this.tabsToShow()
        })
        .catch(() => { this.tab_counts = null })
    },
    getClimbingInfo() {
      getClimbingsGroup(this.$route.params.id)
        .then(response => {
          this.group_detail = response.data
          document.title = `${ this.group_detail.name } (${ this.group_detail.pax }) ID: ${ this.$route.params.id } | Altezza Board`
          this.tabsToShow()
          this.form = {
            name: this.group_detail.name,
            type: this.group_detail.type,
            tour_start: this.group_detail.tour_start,
            route: this.group_detail.route,
            departure_managers: this.group_detail.departure_managers.map(item => item.id),
            starting_point: this.group_detail.starting_point,
            meeting_time: this.group_detail.meeting_time,
            climbing_list: this.group_detail.climbing_list,
            gps: this.group_detail.gps,
            chief_guide: this.group_detail.chief_guide,
          }
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchClimbingsGroups(this.$route.params.id, this.normalizeForm())
        .finally(() => { this.$refs.submit.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Group saved',
          })
          this.$modal.hide(`climbing-group-${this.modal_type}-form`)
          this.getClimbingInfo()
        })
    },
    normalizeForm() {
      let normalizedForm = {}
      if (this.modal_type === 'main') {
        normalizedForm = {
          name: this.form.name,
          type: this.form.type,
          tour_start: this.form.tour_start,
          route: this.form.route,
        }
        normalizedForm.route = typeof normalizedForm.route === 'object' ? normalizedForm.route.id : normalizedForm.route
        normalizedForm.type = typeof normalizedForm.type === 'object' ? normalizedForm.type.code : normalizedForm.type
        // if (this.$store.state.userGroups.map(item => item.code).includes('sales_manager') && this.group_detail.type.code === 'join') {
        //   normalizedForm = {
        //     name: this.form.name
        //   }
        // }
        // if (this.show_edit_btn || (this.$store.state.userGroups.map(item => item.code).includes('sales_manager') && this.group_detail.type.code !== 'join')) {
        //   normalizedForm = {
        //     name: this.form.name,
        //     type: this.form.type,
        //     tour_start: this.form.tour_start,
        //     route: this.form.route,
        //   }
        //   normalizedForm.route = typeof normalizedForm.route === 'object' ? normalizedForm.route.id : normalizedForm.route
        //   normalizedForm.type = typeof normalizedForm.type === 'object' ? normalizedForm.type.code : normalizedForm.type
        // }
      }
      if (this.modal_type === 'start') {
        normalizedForm = {
          departure_managers: this.form.departure_managers,
          starting_point: this.form.starting_point,
          meeting_time: this.form.meeting_time,
        }
        normalizedForm.starting_point = normalizedForm.starting_point.id
      }
      if (this.modal_type === 'room') {
        normalizedForm = {
          climbing_list: this.form.climbing_list,
          gps: this.form.gps,
          chief_guide: this.form.chief_guide,
        }
        if (normalizedForm.gps) normalizedForm.gps = normalizedForm.gps.id
        if (normalizedForm.chief_guide) normalizedForm.chief_guide = normalizedForm.chief_guide.id
      }
      return normalizedForm
    },
    onShowModalEdit(type) {
      this.modal_type = type
      if (type === 'main') {
        this.is_r_t_loading = false
        Promise.all([
          getClimbingGroupType(),
          getClimbingRoutes()
        ])
          .finally(() => { this.is_r_t_loading = true })
          .then(res => {
            this.group_type_options = res[0].data
            this.routes_options = res[1].data
            this.$modal.show('climbing-group-main-form')
          })
      } else if (type === 'start') {
        this.is_u_loading = false
        getUsers({ group: 'operations_manager,operations_supervisor', is_active: true })
          .finally(() => { this.is_u_loading = true })
          .then(res => {
            this.users_options = res.data
            this.$modal.show('climbing-group-start-form')
          })
      } else if (type === 'room') {
        this.is_r_loading = false
        getClimbingGPS()
          .finally(() => { this.is_r_loading = true })
          .then(res => {
            this.gps_options = res.data
            this.$modal.show('climbing-group-room-form')
          })
      }
    },
    onPointSearch(search, loading) {
      loading(true)
      this.searchPoint(loading, search, this)
    },
    searchPoint: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.point_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.point_options = response.data
          loading(false)
        })
      }
    }, 350),
    onGuideSearch(search, loading) {
      loading(true)
      this.searchGuide(loading, search, this)
    },
    searchGuide: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.employees_options = []
      } else {
        getClimbingMountainCrewListSearch({ role: 'guide', search })
          .then(res => {
            loading(false)
            vm.employees_options = res.data
          })
      }
    }, 350),
  }
}
</script>

<style lang="sass">
.detail-title
  color: $color-text-base
  font-size: 24px
  font-weight: 600
  transition: color 0.3s

  &:hover
    color: $color-theme

.detail-holder
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 10px 20px
  margin-bottom: 20px
  align-items: stretch

.detail-editor .ql-editor
  min-height: 52px

.detail-editor .ql-container
  height: auto
</style>
